export default __webpack_public_path__ + "static/media/Linero1.ed96a22b.png";